import React from 'react';

export function SectionIntro({ eyebrow, title, children, light = false }) {
  return <div className={`section-intro ${light ? 'section-intro-light' : ''}`}>
    <span className="eyebrow" data-testid={`${eyebrow.toLowerCase().replaceAll(' ', '-')}-eyebrow`}>{eyebrow}</span>
    <h2 data-testid={`${eyebrow.toLowerCase().replaceAll(' ', '-')}-heading`}>{title}</h2>
    {children && <p data-testid={`${eyebrow.toLowerCase().replaceAll(' ', '-')}-description`}>{children}</p>}
  </div>;
}
